import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsNotEmpty, IsNumber, IsOptional, IsPositive, IsString, IsUUID, MaxLength, MinLength } from 'class-validator'

export class CategoryResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	id: string

	@ApiProperty({ type: String })
	name: string

	@ApiProperty({ type: Number })
	sortOrder: number

	@ApiProperty({ type: Boolean })
	isArchived: boolean

	@ApiProperty({ type: Boolean })
	isVisible: boolean

	@ApiPropertyOptional({ type: String, format: 'uuid' })
	parentCategoryId?: string
}

export class CreateCategoryRequest {
	@ApiProperty({ type: String, minLength: 2, maxLength: 30 })
	@IsNotEmpty()
	@IsString()
	@MinLength(2)
	@MaxLength(30)
	name: string

	@ApiProperty({ type: Number, minimum: 1 })
	@IsNotEmpty()
	@IsNumber()
	@IsPositive()
	sortOrder: number

	@ApiPropertyOptional({ type: String, format: 'uuid' })
	@IsOptional()
	@IsUUID()
	parentCategoryId?: string
}

export class UpdateCategoryRequest extends CreateCategoryRequest {
	@ApiProperty({ type: String, format: 'uuid' })
	@IsNotEmpty()
	@IsUUID()
	id: string
}

export class UpdateSortOrderRequest {
	@ApiProperty({ type: String, format: 'uuid' })
	@IsNotEmpty()
	@IsUUID()
	id: string

	@ApiProperty({ type: Number, minimum: 1 })
	@IsNotEmpty()
	@IsNumber()
	@IsPositive()
	sortOrder: number
}
